module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_bucketpl_m2.3af60e46ec2d251ba453eb59bfc1dddc.png";